import React from 'react';
import { 
  Container, 
  Box, 
  Typography, 
  Paper,
  Divider,
} from '@mui/material';
import { motion } from 'framer-motion';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import { Link } from 'react-router-dom';
import logo from '../assets/BCL_nobg_crop.png';
import './Termsconditions.css';

const TermsConditions = () => {
  return (
    <Box className="terms-section" sx={{ py: 8, background: 'linear-gradient(135deg, #f5f7fa 0%, #e8f4f8 100%)', minHeight: '100vh' }}>
      <Container maxWidth="lg">
        {/* Header Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <Typography
            variant="h2"
            align="center"
            sx={{
              fontFamily: 'Quicksand, sans-serif',
              fontWeight: 700,
              color: '#51A8B1',
              mb: 1.5,
              fontSize: { xs: '2.5rem', md: '3.75rem' },
              letterSpacing: '-0.02em',
            }}
          >
            Terms & Conditions
          </Typography>
          <Typography
            variant="body1"
            align="center"
            sx={{
              fontFamily: 'Quicksand, sans-serif',
              color: '#666',
              mb: 6,
              fontSize: '1.125rem',
              maxWidth: '600px',
              mx: 'auto',
            }}
          >
            Please read these terms carefully before using our services
          </Typography>
        </motion.div>

        {/* Main Content */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.2 }}
        >
          <Paper 
            elevation={3}
            sx={{ 
              p: { xs: 4, md: 8 },
              borderRadius: 4,
              background: 'linear-gradient(145deg, #ffffff 0%, #f9fafb 100%)',
              border: '1px solid rgba(81, 168, 177, 0.1)',
              boxShadow: '0 20px 60px rgba(81, 168, 177, 0.12)',
              mb: 6,
            }}
          >
            <Typography
              variant="body1"
              sx={{
                fontFamily: 'Quicksand, sans-serif',
                color: '#666',
                mb: 4,
                fontSize: '1rem',
                lineHeight: 1.8,
              }}
            >
              <strong>Effective Date:</strong> {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
            </Typography>

            {/* Acceptance */}
            <Typography
              variant="h5"
              sx={{
                fontFamily: 'Barlow, sans-serif',
                fontWeight: 700,
                color: '#51A8B1',
                mb: 2,
                mt: 4,
              }}
            >
              Acceptance of Terms
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: 'Quicksand, sans-serif',
                color: '#666',
                mb: 4,
                fontSize: '1rem',
                lineHeight: 1.8,
              }}
            >
              By accessing and browsing the BioCircuit LABS ("the Company") website or by using and/or downloading any content from same, you agree and accept these Terms and Conditions as set forth below. If you do not agree with these terms, please do not use our website or services.
            </Typography>

            {/* Purpose of Website */}
            <Typography
              variant="h5"
              sx={{
                fontFamily: 'Barlow, sans-serif',
                fontWeight: 700,
                color: '#51A8B1',
                mb: 2,
                mt: 4,
              }}
            >
              Purpose of the Website
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: 'Quicksand, sans-serif',
                color: '#666',
                mb: 2,
                fontSize: '1rem',
                lineHeight: 1.8,
              }}
            >
              All the materials contained in the Company's website are provided for informational purposes only and shall not be construed as:
            </Typography>
            <Box component="ul" sx={{ pl: 4, mb: 4 }}>
              <Typography
                component="li"
                sx={{
                  fontFamily: 'Quicksand, sans-serif',
                  color: '#666',
                  mb: 1.5,
                  fontSize: '1rem',
                  lineHeight: 1.8,
                }}
              >
                A commercial offer
              </Typography>
              <Typography
                component="li"
                sx={{
                  fontFamily: 'Quicksand, sans-serif',
                  color: '#666',
                  mb: 1.5,
                  fontSize: '1rem',
                  lineHeight: 1.8,
                }}
              >
                A license
              </Typography>
              <Typography
                component="li"
                sx={{
                  fontFamily: 'Quicksand, sans-serif',
                  color: '#666',
                  mb: 1.5,
                  fontSize: '1rem',
                  lineHeight: 1.8,
                }}
              >
                An advisory, fiduciary, or professional relationship between you and the Company
              </Typography>
            </Box>
            <Typography
              variant="body1"
              sx={{
                fontFamily: 'Quicksand, sans-serif',
                color: '#666',
                mb: 4,
                fontSize: '1rem',
                lineHeight: 1.8,
              }}
            >
              No information provided on this site shall be considered a substitute for your independent investigation. The information provided on this website may be related to products or services that are not available in your country.
            </Typography>

            {/* Third-Party Links */}
            <Typography
              variant="h5"
              sx={{
                fontFamily: 'Barlow, sans-serif',
                fontWeight: 700,
                color: '#51A8B1',
                mb: 2,
                mt: 4,
              }}
            >
              Links to Third-Party Websites
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: 'Quicksand, sans-serif',
                color: '#666',
                mb: 2,
                fontSize: '1rem',
                lineHeight: 1.8,
              }}
            >
              Links to third-party websites are provided for convenience only and do not imply any approval or endorsement by the Company of the linked sites, even if they may contain the Company's logo, as such sites are beyond the Company's control. Thus, the Company cannot be held responsible for the content of any linked site or any link contained therein.
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: 'Quicksand, sans-serif',
                color: '#666',
                mb: 4,
                fontSize: '1rem',
                lineHeight: 1.8,
              }}
            >
              You acknowledge that framing the Company's website or any similar process is prohibited.
            </Typography>

            {/* Intellectual Property */}
            <Typography
              variant="h5"
              sx={{
                fontFamily: 'Barlow, sans-serif',
                fontWeight: 700,
                color: '#51A8B1',
                mb: 2,
                mt: 4,
              }}
            >
              Intellectual Property
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: 'Quicksand, sans-serif',
                color: '#666',
                mb: 2,
                fontSize: '1rem',
                lineHeight: 1.8,
              }}
            >
              This website is protected by intellectual property rights and is the exclusive property of the Company. Any material that it contains, including, but not limited to, texts, data, graphics, pictures, sounds, videos, logos, icons, or HTML code is protected under intellectual property law and remains the Company's or third party's property.
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: 'Quicksand, sans-serif',
                color: '#666',
                mb: 4,
                fontSize: '1rem',
                lineHeight: 1.8,
              }}
            >
              You may use this material for personal and non-commercial purposes in accordance with the principles governing intellectual property law. Any other use or modification of the content of the Company's website without the Company's prior written authorization is prohibited.
            </Typography>

            {/* Warranty and Liability */}
            <Typography
              variant="h5"
              sx={{
                fontFamily: 'Barlow, sans-serif',
                fontWeight: 700,
                color: '#51A8B1',
                mb: 2,
                mt: 4,
              }}
            >
              Warranty and Liability
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: 'Quicksand, sans-serif',
                color: '#666',
                mb: 2,
                fontSize: '1rem',
                lineHeight: 1.8,
              }}
            >
              All materials, including downloadable software, contained in the Company's website are provided "as is" and without warranty of any kind to the extent allowed by the applicable law. While the Company will use reasonable efforts to provide reliable information through its website, the Company does not warrant that:
            </Typography>
            <Box component="ul" sx={{ pl: 4, mb: 2 }}>
              <Typography
                component="li"
                sx={{
                  fontFamily: 'Quicksand, sans-serif',
                  color: '#666',
                  mb: 1.5,
                  fontSize: '1rem',
                  lineHeight: 1.8,
                }}
              >
                This website is free of inaccuracies, errors, and/or omissions
              </Typography>
              <Typography
                component="li"
                sx={{
                  fontFamily: 'Quicksand, sans-serif',
                  color: '#666',
                  mb: 1.5,
                  fontSize: '1rem',
                  lineHeight: 1.8,
                }}
              >
                The site is free from viruses, worms, Trojan horses, and similar malicious elements
              </Typography>
              <Typography
                component="li"
                sx={{
                  fontFamily: 'Quicksand, sans-serif',
                  color: '#666',
                  mb: 1.5,
                  fontSize: '1rem',
                  lineHeight: 1.8,
                }}
              >
                The content is appropriate for your particular use or up to date
              </Typography>
            </Box>
            <Typography
              variant="body1"
              sx={{
                fontFamily: 'Quicksand, sans-serif',
                color: '#666',
                mb: 2,
                fontSize: '1rem',
                lineHeight: 1.8,
              }}
            >
              The Company reserves the right to change the information at any time without notice. The Company does not warrant any results derived from the use of any software available on this site. You are solely responsible for any use of the materials contained in this site.
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: 'Quicksand, sans-serif',
                color: '#666',
                mb: 4,
                fontSize: '1rem',
                lineHeight: 1.8,
              }}
            >
              The information contained in this site does not extend or modify the warranty that may apply to you as a result of a contractual relationship with the Company.
            </Typography>

            {/* Limitation of Liability */}
            <Typography
              variant="h5"
              sx={{
                fontFamily: 'Barlow, sans-serif',
                fontWeight: 700,
                color: '#51A8B1',
                mb: 2,
                mt: 4,
              }}
            >
              Limitation of Liability
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: 'Quicksand, sans-serif',
                color: '#666',
                mb: 2,
                fontSize: '1rem',
                lineHeight: 1.8,
              }}
            >
              The Company will not be liable for any indirect, consequential, or incidental damages, including but not limited to:
            </Typography>
            <Box component="ul" sx={{ pl: 4, mb: 2 }}>
              <Typography
                component="li"
                sx={{
                  fontFamily: 'Quicksand, sans-serif',
                  color: '#666',
                  mb: 1.5,
                  fontSize: '1rem',
                  lineHeight: 1.8,
                }}
              >
                Lost profits or revenues
              </Typography>
              <Typography
                component="li"
                sx={{
                  fontFamily: 'Quicksand, sans-serif',
                  color: '#666',
                  mb: 1.5,
                  fontSize: '1rem',
                  lineHeight: 1.8,
                }}
              >
                Business interruption
              </Typography>
              <Typography
                component="li"
                sx={{
                  fontFamily: 'Quicksand, sans-serif',
                  color: '#666',
                  mb: 1.5,
                  fontSize: '1rem',
                  lineHeight: 1.8,
                }}
              >
                Loss of data arising out of or in connection with the use, inability to use, or reliance on any material contained in this site or any linked site
              </Typography>
            </Box>
            <Typography
              variant="body1"
              sx={{
                fontFamily: 'Quicksand, sans-serif',
                color: '#666',
                mb: 4,
                fontSize: '1rem',
                lineHeight: 1.8,
              }}
            >
              In any event, the liability of the Company for direct damages arising out of or in connection with the use, inability to use, or reliance on any material contained in this site or any linked site shall not exceed the amount of INR 100,000 (One Hundred Thousand Indian Rupees).
            </Typography>

            {/* User Comments */}
            <Typography
              variant="h5"
              sx={{
                fontFamily: 'Barlow, sans-serif',
                fontWeight: 700,
                color: '#51A8B1',
                mb: 2,
                mt: 4,
              }}
            >
              Users' Comments and Submissions
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: 'Quicksand, sans-serif',
                color: '#666',
                mb: 2,
                fontSize: '1rem',
                lineHeight: 1.8,
              }}
            >
              The Company does not assume any obligation to monitor the information that you may post on its website.
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: 'Quicksand, sans-serif',
                color: '#666',
                mb: 4,
                fontSize: '1rem',
                lineHeight: 1.8,
              }}
            >
              You warrant that any information, materials (the term "Material" is intended to cover all projects, files, or other attachments sent to us), or comments other than personal data that you may transmit to the Company through the website does not infringe intellectual property rights or any other applicable law. Such information, materials, or comments will be treated as non-confidential and non-proprietary. By submitting any information or material, you give the Company an unlimited and irrevocable license to use, execute, show, modify, and transmit such information, material, or comments, including any underlying idea, concept, or know-how. The Company reserves the right to use such information in any way it chooses.
            </Typography>

            {/* Applicable Law */}
            <Typography
              variant="h5"
              sx={{
                fontFamily: 'Barlow, sans-serif',
                fontWeight: 700,
                color: '#51A8B1',
                mb: 2,
                mt: 4,
              }}
            >
              Applicable Law and Jurisdiction
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: 'Quicksand, sans-serif',
                color: '#666',
                mb: 4,
                fontSize: '1rem',
                lineHeight: 1.8,
              }}
            >
              Any controversy or claim arising out of or related to these Terms and Conditions shall be governed by the laws of India. The courts of Delhi, India will have exclusive jurisdiction over any disputes arising from these terms.
            </Typography>

            {/* Severability */}
            <Typography
              variant="h5"
              sx={{
                fontFamily: 'Barlow, sans-serif',
                fontWeight: 700,
                color: '#51A8B1',
                mb: 2,
                mt: 4,
              }}
            >
              Severability
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: 'Quicksand, sans-serif',
                color: '#666',
                mb: 4,
                fontSize: '1rem',
                lineHeight: 1.8,
              }}
            >
              If any provision of these Terms and Conditions is held by a court to be illegal, invalid, or unenforceable, the remaining provisions shall remain in full force and effect.
            </Typography>

            {/* Modifications */}
            <Typography
              variant="h5"
              sx={{
                fontFamily: 'Barlow, sans-serif',
                fontWeight: 700,
                color: '#51A8B1',
                mb: 2,
                mt: 4,
              }}
            >
              Modifications to Terms
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: 'Quicksand, sans-serif',
                color: '#666',
                mb: 4,
                fontSize: '1rem',
                lineHeight: 1.8,
              }}
            >
              The Company reserves the right to change these Terms and Conditions under which this website is offered at any time and without notice. You will be automatically bound by these modifications when you use this site, and should periodically read these Terms and Conditions.
            </Typography>

            {/* Contact Information */}
            <Typography
              variant="h5"
              sx={{
                fontFamily: 'Barlow, sans-serif',
                fontWeight: 700,
                color: '#51A8B1',
                mb: 2,
                mt: 4,
              }}
            >
              Contact Information
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: 'Quicksand, sans-serif',
                color: '#666',
                mb: 2,
                fontSize: '1rem',
                lineHeight: 1.8,
              }}
            >
              If you have any questions about these Terms and Conditions, please contact us:
            </Typography>
            <Box sx={{ pl: 2, mb: 4 }}>
              <Typography
                variant="body1"
                sx={{
                  fontFamily: 'Quicksand, sans-serif',
                  color: '#666',
                  mb: 1,
                  fontSize: '1rem',
                  lineHeight: 1.8,
                }}
              >
                <strong>Email:</strong> info@biocircuitlabs.com
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontFamily: 'Quicksand, sans-serif',
                  color: '#666',
                  fontSize: '1rem',
                  lineHeight: 1.8,
                }}
              >
                <strong>Phone:</strong> +91 94141 74048
              </Typography>
            </Box>
          </Paper>
        </motion.div>
      </Container>

      {/* Footer Section */}
      <Box 
        component="footer" 
        sx={{ 
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)',
          borderTop: '1px solid rgba(81, 168, 177, 0.1)',
          pt: 8,
          pb: 4,
          mt: 12
        }}
      >
        <Container maxWidth="lg">
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 6 }}>
            {/* Logo and Company Info */}
            <Box sx={{ flex: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.3 }}
                >
                  <img 
                    src={logo} 
                    alt="BioCircuit Labs" 
                    style={{ height: '80px', marginRight: '15px' }}
                  />
                </motion.div>
                <Box>
                  <Typography
                    variant="h6"
                    component="span"
                    sx={{ 
                      fontFamily: 'Quicksand, sans-serif',
                      color: '#51A8B1',
                      fontWeight: 700,
                    }}
                  >
                    BioCircuit
                  </Typography>
                  <Typography
                    variant="h6"
                    component="span"
                    sx={{ 
                      fontFamily: 'Barlow, sans-serif',
                      color: '#A8CF45',
                      fontWeight: 700,
                      marginLeft: '8px'
                    }}
                  >
                    LABS
                  </Typography>
                </Box>
              </Box>
              <Typography 
                variant="body2" 
                sx={{ 
                  color: '#666',
                  fontFamily: 'Quicksand, sans-serif',
                  mb: 2,
                  lineHeight: 1.7
                }}
              >
                Transforming healthcare operations through innovative technology solutions.
              </Typography>
            </Box>

            {/* Quick Links */}
            <Box sx={{ flex: 0.6 }}>
              <Typography 
                variant="h6" 
                sx={{ 
                  fontFamily: 'Barlow, sans-serif',
                  color: '#51A8B1',
                  fontWeight: 600,
                  mb: 3
                }}
              >
                Quick Links
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                {[
                  { text: 'Home', path: '/' },
                  { text: 'Careers', path: '/careers' },
                  { text: 'Contact', path: '/contact' }
                ].map((item) => (
                  <motion.div
                    key={item.text}
                    whileHover={{ x: 5 }}
                    transition={{ duration: 0.2 }}
                  >
                    <Link
                      to={item.path}
                      style={{ 
                        textDecoration: 'none',
                        fontFamily: 'Quicksand, sans-serif',
                        color: '#666',
                        fontSize: '0.95rem',
                        transition: 'color 0.3s ease'
                      }}
                      onMouseEnter={(e) => e.target.style.color = '#51A8B1'}
                      onMouseLeave={(e) => e.target.style.color = '#666'}
                    >
                      {item.text}
                    </Link>
                  </motion.div>
                ))}
              </Box>
            </Box>

            {/* Legal */}
            <Box sx={{ flex: 0.6 }}>
              <Typography 
                variant="h6" 
                sx={{ 
                  fontFamily: 'Barlow, sans-serif',
                  color: '#51A8B1',
                  fontWeight: 600,
                  mb: 3
                }}
              >
                Legal
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                {[
                  { text: 'Privacy Policy', path: '/privacy-policy' },
                  { text: 'Terms & Conditions', path: '/terms-conditions' }
                ].map((item) => (
                  <motion.div
                    key={item.text}
                    whileHover={{ x: 5 }}
                    transition={{ duration: 0.2 }}
                  >
                    <Link
                      to={item.path}
                      style={{ 
                        textDecoration: 'none',
                        fontFamily: 'Quicksand, sans-serif',
                        color: '#666',
                        fontSize: '0.95rem',
                        transition: 'color 0.3s ease'
                      }}
                      onMouseEnter={(e) => e.target.style.color = '#51A8B1'}
                      onMouseLeave={(e) => e.target.style.color = '#666'}
                    >
                      {item.text}
                    </Link>
                  </motion.div>
                ))}
              </Box>
            </Box>

            {/* Contact Info */}
            <Box sx={{ flex: 0.8 }}>
              <Typography 
                variant="h6" 
                sx={{ 
                  fontFamily: 'Barlow, sans-serif',
                  color: '#51A8B1',
                  fontWeight: 600,
                  mb: 3
                }}
              >
                Contact Us
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <EmailIcon sx={{ color: '#51A8B1', fontSize: '1.2rem' }} />
                  <Typography
                    sx={{ 
                      fontFamily: 'Quicksand, sans-serif',
                      color: '#666',
                      fontSize: '0.95rem'
                    }}
                  >
                    info@biocircuitlabs.com
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <PhoneIcon sx={{ color: '#51A8B1', fontSize: '1.2rem' }} />
                  <Typography
                    sx={{ 
                      fontFamily: 'Quicksand, sans-serif',
                      color: '#666',
                      fontSize: '0.95rem'
                    }}
                  >
                    +91 94141 74048
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>

          {/* Bottom Bar */}
          <Divider sx={{ my: 4, borderColor: 'rgba(81, 168, 177, 0.1)' }} />
          <Box 
            sx={{ 
              display: 'flex', 
              justifyContent: 'center',
              alignItems: 'center',
              flexWrap: 'wrap',
              gap: 1
            }}
          >
            <Typography 
              variant="body2" 
              sx={{ 
                fontFamily: 'Quicksand, sans-serif',
                color: '#666',
                textAlign: 'center'
              }}
            >
              © {new Date().getFullYear()} BioCircuit Labs. All rights reserved.
            </Typography>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default TermsConditions;